import Backbone from 'backbone';
import Radio from 'backbone.radio';
import Api from '@/lib/api/api';
import VersionInformationView from '@/views/version_information_view';

    var globalCh = Radio.channel('global');
    function add_version_info_popover(target) {
        function onFetchApiVersion(model) {
            /*
            * Options for the Version Info View
            */
            var app_features = globalCh.request('app_options', 'features');
            var vi_options = {
                api_version: model.get('version'),
                beta_feedback: app_features && app_features.beta_feedback
            };
            var vi_view = new VersionInformationView(vi_options);

            /*
            * Options for the Popover
            */
            var popover_options = {
                /* commenting these out for removal, in case they should be wanted back
                 * environment_name : app_features.environment_name,
                 * link_title : vi_view.options.ide_version,
                 */
                target : target,
                content : vi_view
            };
            globalCh.request('addPopover', popover_options);
        }

        var ApiVersion = Backbone.Model.extend({
            url : Api.urls.ide_version(),
            sync: Api.sync
        });

        var myApiVersion = new ApiVersion();
        myApiVersion.fetch({success: onFetchApiVersion});

    }
    export default add_version_info_popover;

